/* global debounce */
if (!customElements.get('buy-btn-color')) {
  class BuyBtnColor extends HTMLElement {
    constructor() {
      super();
     
    }

    async init(){
      const rgbString = await this.getBgColor();
      console.log('rgbString', rgbString)
      const cleanedString = rgbString?.replace(/rgb\(|\)|\s+/g, "") || null;
      this.changeColors(cleanedString);
    }

    getBgColor() {
      return new Promise((resolve) => {
          const rightColumn = document.querySelector('.product-column-right');
  
          if (!rightColumn) {
              resolve(null);
              return;
          }
  
          const observer = new MutationObserver((mutationsList, observer) => {
              for (let mutation of mutationsList) {
                  if (mutation.addedNodes.length > 0) {
                      const node = mutation.addedNodes[0];
                      if (node.classList.contains('globo-product-groups-detail')) {
                          const activeItem = rightColumn.querySelector('.is-gsw-active span');
                          if (activeItem) {
                              const bgColor = activeItem.style.backgroundColor;
                              observer.disconnect(); // Stop observing after finding the value
                              resolve(bgColor);
                          }
                      }
                  }
              }
          });
  
          // Start observing
          observer.observe(rightColumn, { childList: true, subtree: true });

          // Timeout to prevent infinite waiting (e.g., 3 seconds)
          setTimeout(() => {
            observer.disconnect();
            resolve(null); // Resolve with null or default color if not found
        }, 500);
      });
  }

    changeColors(rgbBg) {
      const bgColor = this.getAttribute("data-color");
      
      if(!bgColor && !rgbBg || rgbBg === 'initial') return;

      const atcBtn = document.querySelector('buy-buttons .add-to-cart');
      const announcementBar = document.querySelector('announcement-bar');
      const announcement = announcementBar.querySelector('.announcement');

      function hexToRgb(hex) {
        // Remove the "#" if present
        hex = hex.replace("#", "");
      
        // Parse the r, g, b values
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
      
        return `${r}, ${g}, ${b}`;
      }
    
      function getTextColor(hexColor) {
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
        return luminance > 186 ? "0,0,0": "255,255,255";
      }
    
      const rgbBgColor = rgbBg ? rgbBg : hexToRgb(bgColor);
      console.log('!!!',rgbBgColor)
      const rgbTextColor = getTextColor(bgColor) === "0,0,0" ? "0,0,0": "255,255,255";
      atcBtn.style.setProperty('--btn-border-color', rgbBgColor);
      atcBtn.style.setProperty('--btn-bg-color', rgbBgColor);
      atcBtn.style.setProperty('--btn-text-color', rgbTextColor);
      if(rgbBgColor === "255,255,255") atcBtn.style.setProperty('--btn-border-color', rgbTextColor);
      if(rgbBgColor === "255,255,255") console.log('bialy')
      console.log(rgbBgColor)


      announcementBar.style.backgroundColor = rgbBg ? `rgb(${rgbBg})` : bgColor;
      announcementBar.style.setProperty('--bg-color', rgbBgColor);
      announcementBar.style.setProperty('--text-color', rgbTextColor);
      announcementBar.style.setProperty('--link-color', rgbTextColor);
      announcementBar.style.setProperty('--heading-color', rgbTextColor);
      announcement.style.setProperty('--text-color', rgbTextColor);
    }

    connectedCallback(){
      this.changeColors = this.changeColors.bind(this);


      this.init();
    }
  }

  customElements.define('buy-btn-color', BuyBtnColor);
}
